const tenantApps = {
	2: "bilkamadudafhuset",
	3: "foetexudafhuset",
	5: "smagsalling",
	6: "carlsjrapp"
};
const productionUrls = {
	2: "https://www.bilkamadudafhuset.dk",
	3: "https://www.foetexudafhuset.dk",
	5: "https://www.smagsalling.dk",
	6: "https://www.app.carls-jr.dk"
};
const deployedEnvironments = ["d", "o", "t"];
const localUrls = Object.keys(tenantApps).reduce((urls, tenantId) => ({
	...urls,
	[tenantId]: "http://localhost:8081"
}), {});

export const orderEditUrlMap = {
	a: localUrls,
	p: Object.keys(tenantApps).reduce((urls, tenantId) => ({
		...urls,
		[tenantId]: productionUrls[tenantId]
	}), {})
};

deployedEnvironments.forEach(environment => {
	orderEditUrlMap[environment] = Object.keys(tenantApps).reduce((urls, tenantId) => ({
		...urls,
		[tenantId]: `https://${environment}3-${tenantApps[tenantId]}.dsgapps.dk`
	}), {});
});

export function getOrderEditUrls(environment, tenantId) {
	const normalizedEnvironment = environment.replace(/-env.*$/, "");
	const url = (orderEditUrlMap[normalizedEnvironment] || {})[tenantId];

	if (!url) {
		throw new Error(`Missing order edit URLs for environment ${normalizedEnvironment}, tenant ${tenantId}`);
	}

	return url;
}
